import React from 'react';
import { Box } from '@drivekyte/web-components';
import { useMedia, Typography } from '@drivekyte/ui';
import Image from 'next/image';

export type InfoItemProps = {
  icon: string;
  title: string;
  text: string;
  index: number;
};

const InfoItem = ({ icon, title, text, index }: InfoItemProps) => {
  const media = useMedia();
  const isTablet = media.sm;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      marginBottom="xxxLarge"
      width="100%"
    >
      <Box maxWidth="300px">
        <Box marginBottom="base" textAlign="center" width="100%">
          <Image
            src={`/images/icons/${icon}.svg`}
            width={50}
            height={50}
            alt=""
          />
        </Box>
        <Box marginBottom="tiny">
          <Typography
            variant="headingMedium"
            textAlign={isTablet ? 'center' : 'auto'}
          >
            {`${index + 1}. ${title}`}
          </Typography>
        </Box>
        <Typography
          variant="paragraphMedium"
          textAlign={isTablet ? 'center' : 'auto'}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoItem;
